import { useGetVersionStatusQuery } from "fond/api";
import { useAppSelector } from "fond/utils/hooks";

import { getDesignEdits } from "../designEdits";

/**
 * Return the design edits that are present in the current version.
 */
export const useDesignEdits = (): ReturnType<typeof getDesignEdits> => {
  const versionId = useAppSelector((state) => state.project.versionId);
  const { currentData: versionStatus } = useGetVersionStatusQuery(versionId, { skip: !versionId });

  return getDesignEdits(versionStatus);
};
